import { createSelector } from 'reselect';

export const getSquares = (state) => {
  return state.squares;
}

/*
  returns a hierarchy of squares information.
*/

export const getSquaresHierarchy = createSelector(
  [getSquares],
  (squares) => {
    return Object.keys(squares).reduce( (acc, square_id) => {
      const parent_id = squares[square_id].parent_id;
      if (parent_id !== null) {
        if (acc[parent_id] === undefined) {
          acc[parent_id] = [];
        }
        acc[parent_id].push(square_id);
      }
      return acc;
    }, {})
  }
);

export const getSelectedSquares = createSelector(
  [getSquares],
  (squares) => {
    return Object.values(squares).filter( sq => sq.selected);
  }
);

export const getDescendants = createSelector(
  [getSquaresHierarchy],
  (hierarchy) => {
    let descendants = {};
    //let ancestors = {};
    Object.keys(hierarchy).forEach(square_id => {
      if (descendants[square_id] === undefined) {
        descendants[square_id] = [];
      }
      descendants[square_id].push(...hierarchy[square_id]);
    })
  }
);



// WEBPACK FOOTER //
// ./src/selectors/squares.js